<template lang="pug">
  .order-item
    .product-image.xs-4
      ProductInfoImage(:imagery="product.imagery")

    .product-details.xs-8.md-4
      p.prod-type.bold.upper.xs-f-xsmall.lg-f-small.max-at-tweak(data-mr-ass="product-details") {{ product.product_type_display_name }}
      p.prod-desc.color-slate.xs-f-xsmall.lg-f-small.max-at-tweak(data-mr-ass="product-name") {{ product.name }}
      p.qty.xs-f-small.lg-f-medium.max-at-tweak(data-mr-ass="order-quantity") QTY: {{ item.qty }}
      p.unit-price.xs-f-small.lg-f-medium.max-at-tweak(data-mr-ass="unit-price") {{ item.unit_price | currency }}

    .product-ctas.xs-12.md-4(v-if="product.reorderable && product.product_type != 'extra_tube'")
      a.buy-again.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(@click="buyAgain" data-mr-ass="buy-again-button") buy again
      a.mr-btn.btn-block.btn-inverse.xs-f-xsmall.max-at-tweak(v-if="invoiceStatus == 'delivered'" @click.prevent="writeReview") {{ product.rating ? 'Edit' : 'Write a' }} review
  
</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    name: "OrderItem",
    components: {
      'ProductInfoImage': () => import('../../ProductInfoImage')
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      invoiceStatus: {
        type: String
      }
    },

    computed: {
      product() {
        return this.item.product || {};
      }
    },

    methods: {
      ...mapActions('cart', [
        'addToCart'
      ]),

      writeReview() {
        var href = `/product/${this.product.url_key}/review`;
        window.location.href = href;
      },

      buyAgain() {
        this.addToCart({ productId: this.product.id }).then(() => {
          this.goToPath('/cart');
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .order-item
    padding 1.75em 0
    border-bottom 1px solid #ccc

    &:last-child
      border-bottom none

    .product-details
      padding-left 0.75em

      .prod-desc
        padding 0.5em 0

      .qty
      .unit-price
        display inline-block
        vertical-align top

      .qty
        padding-right 2em

    .product-ctas
      .buy-again
        margin-top 2em
        margin-bottom 1em

    @media mq-desktop-md
      .product-details
        padding-left 1.5em

      .product-ctas
        padding-left 5%

        .buy-again
          margin-top 0

    @media mq-desktop-plus
      .product-details
        padding-left 1.5em

      .product-ctas
        padding-left 5%

        .buy-again
          margin-top 0

</style>